// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import peripheral from './metaData/peripheral'
export default {
  state: peripheral,
  actions
}
